<template>
    <div class="gynecology-section-modern">
        <div class="section-header-modern">
            <div class="header-title-modern">
                <i class="fas fa-venus"></i>
                <h4>{{ apiData.title || 'Ginecología y Obstetricia' }}</h4>
            </div>
        </div>

        <!-- Datos Ginecológicos Generales -->
        <div class="subsection-header-modern">
            <i class="fas fa-calendar-alt"></i>
            <h5>Antecedentes Ginecológicos</h5>
        </div>

        <!-- Botones para agregar campos ginecológicos -->
        <div v-if="inactiveGynecologicalFields.length > 0" class="add-fields-section">
            <button
v-for="field in inactiveGynecologicalFields" :key="field.name" class="add-field-btn"
                :title="'Agregar ' + field.label" @click="addField(field.name)">
                <i :class="field.icon"></i>
                <span>{{ field.label }}</span>
            </button>
        </div>

        <div v-if="activeGynecologicalFields.length > 0" class="fields-grid-compact">
            <div v-if="isFieldActive('menarche')" class="field-group-compact">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-calendar-day"></i>
                            <span>{{ menarcheLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isFieldCloseable('menarche')" class="close-field-btn" title="Cerrar campo"
                        @click="removeField('menarche')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <input v-model="menarche" type="text" class="form-input-modern" placeholder="Edad en años" />
            </div>

            <div v-if="isFieldActive('cycle')" class="field-group-compact">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-sync"></i>
                            <span>{{ cycleLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isFieldCloseable('cycle')" class="close-field-btn" title="Cerrar campo"
                        @click="removeField('cycle')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <input v-model="cycle" type="text" class="form-input-modern" placeholder="Ej: 28/4" />
            </div>

            <div v-if="isFieldActive('eumenorrhea')" class="field-group-compact">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-check-circle"></i>
                            <span>{{ eumenorrheaLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isFieldCloseable('eumenorrhea')" class="close-field-btn" title="Cerrar campo"
                        @click="removeField('eumenorrhea')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <input v-model="eumenorrhea" type="text" class="form-input-modern" placeholder="Sí/No" />
            </div>

            <div v-if="isFieldActive('dysmenorrhea')" class="field-group-compact">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-heartbeat"></i>
                            <span>{{ dysmenorrheaLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isFieldCloseable('dysmenorrhea')" class="close-field-btn" title="Cerrar campo"
                        @click="removeField('dysmenorrhea')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <input v-model="dysmenorrhea" type="text" class="form-input-modern" placeholder="Sí/No" />
            </div>

            <div v-if="isFieldActive('sexual_activity_start_age')" class="field-group-compact">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-user-clock"></i>
                            <span>{{ sexualActivityStartAgeLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isFieldCloseable('sexual_activity_start_age')" class="close-field-btn"
                        title="Cerrar campo" @click="removeField('sexual_activity_start_age')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <input
v-model="sexual_activity_start_age" type="text" class="form-input-modern"
                    placeholder="Edad en años" />
            </div>

            <div v-if="isFieldActive('sexual_partners')" class="field-group-compact">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-users"></i>
                            <span>{{ sexualPartnersLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isFieldCloseable('sexual_partners')" class="close-field-btn" title="Cerrar campo"
                        @click="removeField('sexual_partners')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <input v-model="sexual_partners" type="text" class="form-input-modern" placeholder="Número" />
            </div>

            <div v-if="isFieldActive('contraceptive_method_id')" class="field-group-compact">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-shield-alt"></i>
                            <span>{{ contraceptiveMethodLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isFieldCloseable('contraceptive_method_id')" class="close-field-btn"
                        title="Cerrar campo" @click="removeField('contraceptive_method_id')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <MenuSelectedFull
v-model="contraceptive_method_id" :label="''" :category="'10'"
                    :local-data="familyPlanningMethods" :can-edit-and-add="false" />
            </div>

            <div v-if="isFieldActive('cancer_screening')" class="field-group-compact">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-microscope"></i>
                            <span>{{ cancerScreeningLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isFieldCloseable('cancer_screening')" class="close-field-btn" title="Cerrar campo"
                        @click="removeField('cancer_screening')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <input
v-model="cancer_screening" type="text" class="form-input-modern"
                    placeholder="Fecha del último estudio" />
            </div>
        </div>

        <!-- Antecedentes Obstétricos -->
        <div class="subsection-header-modern" style="margin-top: 2rem;">
            <i class="fas fa-baby"></i>
            <h5>Antecedentes Obstétricos</h5>
        </div>

        <!-- Botones para agregar campos obstétricos -->
        <div v-if="inactiveObstetricFields.length > 0" class="add-fields-section">
            <button
v-for="field in inactiveObstetricFields" :key="field.name" class="add-field-btn"
                :title="'Agregar ' + field.label" @click="addField(field.name)">
                <i :class="field.icon"></i>
                <span>{{ field.label }}</span>
            </button>
        </div>

        <div v-if="activeObstetricFields.length > 0" class="fields-grid-compact">
            <div v-if="isFieldActive('pregnancies')" class="field-group-compact">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-baby-carriage"></i>
                            <span>{{ pregnanciesLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isFieldCloseable('pregnancies')" class="close-field-btn" title="Cerrar campo"
                        @click="removeField('pregnancies')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <input v-model="pregnancies" type="text" class="form-input-modern" placeholder="Número" />
            </div>

            <div v-if="isFieldActive('cesarean_sections')" class="field-group-compact">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-procedures"></i>
                            <span>{{ cesareanSectionsLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isFieldCloseable('cesarean_sections')" class="close-field-btn" title="Cerrar campo"
                        @click="removeField('cesarean_sections')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <input v-model="cesarean_sections" type="text" class="form-input-modern" placeholder="Número" />
            </div>

            <div v-if="isFieldActive('deliveries')" class="field-group-compact">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-hand-holding-heart"></i>
                            <span>{{ deliveriesLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isFieldCloseable('deliveries')" class="close-field-btn" title="Cerrar campo"
                        @click="removeField('deliveries')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <input v-model="deliveries" type="text" class="form-input-modern" placeholder="Número" />
            </div>

            <div v-if="isFieldActive('abortions')" class="field-group-compact">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-times-circle"></i>
                            <span>{{ abortionsLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isFieldCloseable('abortions')" class="close-field-btn" title="Cerrar campo"
                        @click="removeField('abortions')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <input v-model="abortions" type="text" class="form-input-modern" placeholder="Número" />
            </div>
        </div>

        <!-- Exámenes Ginecológicos - Campo Principal -->
        <div v-if="!isGynecologicalExamsActive" class="add-fields-section">
            <button class="add-field-btn" title="Agregar Exámenes Ginecológicos" @click="addGynecologicalExams">
                <i class="fas fa-file-medical-alt"></i>
                <span>{{ gynecologicalExamsLabel }}</span>
            </button>
        </div>

        <div v-if="isGynecologicalExamsActive" class="gynecological-exams-section">
            <div class="field-header">
                <label class="form-label-modern">
                    <span class="label-content-modern">
                        <i class="fas fa-file-medical-alt"></i>
                        <span>{{ gynecologicalExamsLabel }}</span>
                    </span>
                </label>
                <button class="close-field-btn" title="Cerrar campo" @click="removeGynecologicalExams">
                    <i class="fas fa-times"></i>
                </button>
            </div>
            <div class="textarea-wrapper-modern">
                <textarea
v-model="gynecological_exams" class="form-textarea-modern"
                    placeholder="Describe los exámenes ginecológicos realizados, resultados de papanicolaou, colposcopías, ultrasonidos, mastografías, etc..."
                    rows="4"></textarea>
                <div class="textarea-footer-modern">
                    <div class="textarea-stats-modern">
                        <span class="stat-item-modern">
                            <i class="fas fa-font"></i>
                            {{ gynecological_exams.length }} caracteres
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Otros Datos -->
        <div class="subsection-header-modern" style="margin-top: 2rem;">
            <i class="fas fa-info-circle"></i>
            <h5>Información Adicional</h5>
        </div>

        <!-- Botones para agregar campos adicionales -->
        <div v-if="inactiveAdditionalFields.length > 0" class="add-fields-section">
            <button
v-for="field in inactiveAdditionalFields" :key="field.name" class="add-field-btn"
                :title="'Agregar ' + field.label" @click="addField(field.name)">
                <i :class="field.icon"></i>
                <span>{{ field.label }}</span>
            </button>
        </div>

        <div v-if="activeAdditionalFields.length > 0" class="fields-grid-compact">
            <div v-if="isFieldActive('menopause')" class="field-group-compact">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-female"></i>
                            <span>{{ menopauseLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isFieldCloseable('menopause')" class="close-field-btn" title="Cerrar campo"
                        @click="removeField('menopause')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <ToggleButton
v-model="menopause" :label="''" :options="[
                    { id: 1, label: 'Sí' },
                    { id: 2, label: 'No' }
                ]" :input-condition="[]" />
            </div>

            <div v-if="isFieldActive('infertility')" class="field-group-compact">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-exclamation-triangle"></i>
                            <span>{{ infertilityLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isFieldCloseable('infertility')" class="close-field-btn" title="Cerrar campo"
                        @click="removeField('infertility')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <ToggleButton
v-model="infertility" :label="''" :options="[
                    { id: 1, label: 'Sí' },
                    { id: 2, label: 'No' }
                ]" :input-condition="[]" />
            </div>

            <div v-if="isFieldActive('stage')" class="field-group-compact">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-layer-group"></i>
                            <span>{{ stageLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isFieldCloseable('stage')" class="close-field-btn" title="Cerrar campo"
                        @click="removeField('stage')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <ToggleButton
v-model="stage" :label="''" :options="[
                    { id: 1, label: '1ª' },
                    { id: 2, label: '2ª' }
                ]" :input-condition="[]" />
            </div>

            <div v-if="isFieldActive('treatment')" class="field-group-compact">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-pills"></i>
                            <span>{{ treatmentLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isFieldCloseable('treatment')" class="close-field-btn" title="Cerrar campo"
                        @click="removeField('treatment')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <ToggleButton
v-model="treatment" :text-value="treatment_description" :label="''" :options="[
                    { id: 1, label: 'Sí' },
                    { id: 2, label: 'No' }
                ]" :input-condition="[1]" @update:text-value="updateTreatmentDescriptionText" />
            </div>
        </div>

        <div class="last-updated-wrapper">
            <LastUpdated :updated-at="updated_at" />
        </div>
    </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import MenuSelectedFull from '@/components/MenuSelectedFull.vue';
import { familyPlanningMethods } from '@/data/menuvalues';
import ToggleButton from '@/components/ToggleButton.vue';
import LastUpdated from '@/components/LastUpdated.vue';
import api from '@/services/api';
import debounce from 'lodash.debounce';

const props = defineProps({
    patientRecord: {
        type: Object,
        required: true
    },
    data: {
        type: Object,
        default: () => ({})
    }
});

// API Data para el título
const apiData = {
    title: 'Ginecología y Obstetricia'
};

// Definir campos ginecológicos
const gynecologicalFields = ref([
    { name: 'menarche', label: 'Menarca', icon: 'fas fa-calendar-day', model: '', isActive: false, closeable: true },
    { name: 'cycle', label: 'Ritmo', icon: 'fas fa-sync', model: '', isActive: false, closeable: true },
    { name: 'eumenorrhea', label: 'Eumenorreica', icon: 'fas fa-check-circle', model: '', isActive: false, closeable: true },
    { name: 'dysmenorrhea', label: 'Dismenorrea', icon: 'fas fa-heartbeat', model: '', isActive: false, closeable: true },
    { name: 'sexual_activity_start_age', label: 'IVSA', icon: 'fas fa-user-clock', model: '', isActive: false, closeable: true },
    { name: 'sexual_partners', label: 'Parejas Sexuales', icon: 'fas fa-users', model: '', isActive: false, closeable: true },
    { name: 'contraceptive_method_id', label: 'Método Planificación', icon: 'fas fa-shield-alt', model: '', isActive: false, closeable: true },
    { name: 'cancer_screening', label: 'Detección Oportuna de Cáncer', icon: 'fas fa-microscope', model: '', isActive: false, closeable: true }
]);

// Definir campos obstétricos
const obstetricFields = ref([
    { name: 'pregnancies', label: 'Gestas', icon: 'fas fa-baby-carriage', model: '', isActive: false, closeable: true },
    { name: 'cesarean_sections', label: 'Cesáreas', icon: 'fas fa-procedures', model: '', isActive: false, closeable: true },
    { name: 'deliveries', label: 'Partos', icon: 'fas fa-hand-holding-heart', model: '', isActive: false, closeable: true },
    { name: 'abortions', label: 'Abortos', icon: 'fas fa-times-circle', model: '', isActive: false, closeable: true }
]);

// Definir campos adicionales (ToggleButton)
const additionalFields = ref([
    { name: 'menopause', label: 'Menopausia', icon: 'fas fa-female', model: 0, isActive: false, closeable: true },
    { name: 'infertility', label: 'Infertilidad', icon: 'fas fa-exclamation-triangle', model: 0, isActive: false, closeable: true },
    { name: 'stage', label: 'Etapa', icon: 'fas fa-layer-group', model: 0, isActive: false, closeable: true },
    { name: 'treatment', label: 'Tratamiento', icon: 'fas fa-pills', model: 0, isActive: false, closeable: true }
]);

// Computed para campos inactivos
const inactiveGynecologicalFields = computed(() =>
    gynecologicalFields.value.filter(field => !field.isActive)
);

const inactiveObstetricFields = computed(() =>
    obstetricFields.value.filter(field => !field.isActive)
);

const inactiveAdditionalFields = computed(() =>
    additionalFields.value.filter(field => !field.isActive)
);

// Computed para campos activos
const activeGynecologicalFields = computed(() =>
    gynecologicalFields.value.filter(field => field.isActive)
);

const activeObstetricFields = computed(() =>
    obstetricFields.value.filter(field => field.isActive)
);

const activeAdditionalFields = computed(() =>
    additionalFields.value.filter(field => field.isActive)
);

// Funciones para agregar y quitar campos
const addField = (fieldName) => {
    const allFields = [...gynecologicalFields.value, ...obstetricFields.value, ...additionalFields.value];
    const field = allFields.find(f => f.name === fieldName);
    if (field) {
        field.isActive = true;
    }
};

const removeField = (fieldName) => {
    const allFields = [...gynecologicalFields.value, ...obstetricFields.value, ...additionalFields.value];
    const field = allFields.find(f => f.name === fieldName);
    if (field && field.closeable) {
        field.isActive = false;
    }
};

const isFieldActive = (fieldName) => {
    const allFields = [...gynecologicalFields.value, ...obstetricFields.value, ...additionalFields.value];
    const field = allFields.find(f => f.name === fieldName);
    return field ? field.isActive : false;
};

const isFieldCloseable = (fieldName) => {
    const allFields = [...gynecologicalFields.value, ...obstetricFields.value, ...additionalFields.value];
    const field = allFields.find(f => f.name === fieldName);
    return field ? field.closeable : false;
};

// Helpers para obtener valores de campos
const getFieldValue = (fieldName) => {
    const allFields = [...gynecologicalFields.value, ...obstetricFields.value, ...additionalFields.value];
    const field = allFields.find(f => f.name === fieldName);
    return field ? field.model : '';
};

const setFieldValue = (fieldName, value) => {
    const allFields = [...gynecologicalFields.value, ...obstetricFields.value, ...additionalFields.value];
    const field = allFields.find(f => f.name === fieldName);
    if (field) {
        field.model = value;
        debouncedSaveGynecologyData();
    }
};

// Referencias individuales para v-model
const menarche = computed({
    get: () => getFieldValue('menarche'),
    set: (val) => setFieldValue('menarche', val)
});
const cycle = computed({
    get: () => getFieldValue('cycle'),
    set: (val) => setFieldValue('cycle', val)
});

const eumenorrhea = computed({
    get: () => getFieldValue('eumenorrhea'),
    set: (val) => setFieldValue('eumenorrhea', val)
});

const dysmenorrhea = computed({
    get: () => getFieldValue('dysmenorrhea'),
    set: (val) => setFieldValue('dysmenorrhea', val)
});

const sexual_activity_start_age = computed({
    get: () => getFieldValue('sexual_activity_start_age'),
    set: (val) => setFieldValue('sexual_activity_start_age', val)
});

const sexual_partners = computed({
    get: () => getFieldValue('sexual_partners'),
    set: (val) => setFieldValue('sexual_partners', val)
});

const contraceptive_method_id = computed({
    get: () => getFieldValue('contraceptive_method_id'),
    set: (val) => setFieldValue('contraceptive_method_id', val)
});

const cancer_screening = computed({
    get: () => getFieldValue('cancer_screening'),
    set: (val) => setFieldValue('cancer_screening', val)
});

const pregnancies = computed({
    get: () => getFieldValue('pregnancies'),
    set: (val) => setFieldValue('pregnancies', val)
});

const cesarean_sections = computed({
    get: () => getFieldValue('cesarean_sections'),
    set: (val) => setFieldValue('cesarean_sections', val)
});

const deliveries = computed({
    get: () => getFieldValue('deliveries'),
    set: (val) => setFieldValue('deliveries', val)
});

const abortions = computed({
    get: () => getFieldValue('abortions'),
    set: (val) => setFieldValue('abortions', val)
});

const menopause = computed({
    get: () => getFieldValue('menopause'),
    set: (val) => setFieldValue('menopause', val)
});

const infertility = computed({
    get: () => getFieldValue('infertility'),
    set: (val) => setFieldValue('infertility', val)
});

const stage = computed({
    get: () => getFieldValue('stage'),
    set: (val) => setFieldValue('stage', val)
});

const treatment = computed({
    get: () => getFieldValue('treatment'),
    set: (val) => setFieldValue('treatment', val)
});

const gynecological_exams = ref('');
const isGynecologicalExamsActive = ref(false);

const addGynecologicalExams = () => {
    isGynecologicalExamsActive.value = true;
};

const removeGynecologicalExams = () => {
    isGynecologicalExamsActive.value = false;
};

const treatment_description = ref('');
const updated_at = ref('');

// Labels
const menarcheLabel = 'Menarca';
const cycleLabel = 'Ritmo';
const eumenorrheaLabel = 'Eumenorreica';
const dysmenorrheaLabel = 'Dismenorrea';
const sexualActivityStartAgeLabel = 'IVSA';
const sexualPartnersLabel = 'Parejas Sexuales';
const contraceptiveMethodLabel = 'Método Planificación';
const cancerScreeningLabel = 'Detección Oportuna de Cáncer';
const pregnanciesLabel = 'Gestas';
const cesareanSectionsLabel = 'Cesáreas';
const deliveriesLabel = 'Partos';
const abortionsLabel = 'Abortos';
const gynecologicalExamsLabel = 'Exámenes Ginecológicos';
const menopauseLabel = 'Menopausia';
const infertilityLabel = 'Infertilidad';
const stageLabel = 'Etapa';
const treatmentLabel = 'Tratamiento';

const updateTreatmentDescriptionText = (newValue) => {
    treatment_description.value = newValue;
    debouncedSaveGynecologyData();
};

const saveGynecologyData = async () => {
    const gynecologyData = {
        gynecology: {
            menarche: menarche.value,
            cycle: cycle.value,
            eumenorrhea: eumenorrhea.value,
            dysmenorrhea: dysmenorrhea.value,
            sexual_activity_start_age: sexual_activity_start_age.value,
            sexual_partners: sexual_partners.value,
            contraceptive_method_id: contraceptive_method_id.value,
            cancer_screening: cancer_screening.value,
            pregnancies: pregnancies.value,
            cesarean_sections: cesarean_sections.value,
            deliveries: deliveries.value,
            abortions: abortions.value,
            gynecological_exams: gynecological_exams.value,
            menopause: menopause.value,
            infertility: infertility.value,
            stage: stage.value,
            treatment: treatment.value,
            treatment_description: treatment_description.value
        }
    };

    try {
        const response = await api.put(`/pacientes/${props.patientRecord.id}/gynecology`, gynecologyData);
        const updatedAt = new Date(response.data.data.gynecology.updated_at);
        updated_at.value = updatedAt.toString();
    } catch (error) {
        console.error('Error al guardar los datos de ginecología:', error);
    }
};

// Debounce la función saveGynecologyData
const debouncedSaveGynecologyData = debounce(saveGynecologyData, 1000);

watch(() => props.data, (newData) => {
    if (newData) {
        // Cargar datos ginecológicos - solo activar si tienen datos
        gynecologicalFields.value.forEach(field => {
            if (newData[field.name] !== undefined && newData[field.name] !== '' && newData[field.name] !== null) {
                field.model = newData[field.name];
                field.isActive = true;
            } else {
                field.model = '';
                field.isActive = false;
            }
        });

        // Cargar datos obstétricos - solo activar si tienen datos
        obstetricFields.value.forEach(field => {
            if (newData[field.name] !== undefined && newData[field.name] !== '' && newData[field.name] !== null) {
                field.model = newData[field.name];
                field.isActive = true;
            } else {
                field.model = '';
                field.isActive = false;
            }
        });

        // Cargar datos adicionales - solo activar si tienen datos
        additionalFields.value.forEach(field => {
            if (newData[field.name] !== undefined && newData[field.name] !== 0 && newData[field.name] !== null) {
                field.model = newData[field.name];
                field.isActive = true;
            } else {
                field.model = 0;
                field.isActive = false;
            }
        });

        gynecological_exams.value = newData.gynecological_exams || '';
        isGynecologicalExamsActive.value = gynecological_exams.value !== '' && gynecological_exams.value !== null;

        treatment_description.value = newData.treatment_description || '';

        if (newData.updated_at) {
            updated_at.value = new Date(newData.updated_at).toString();
        }
    }
}, { immediate: true });
</script>

<style scoped>
.gynecology-section-modern {
    background: transparent;
    border-radius: 0;
    padding: 0 1.5rem;
    margin-bottom: 1.5rem;
}

/* Section Header */
.section-header-modern {
    margin-bottom: 0.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #f0f2f5;
}

.header-title-modern {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.header-title-modern i {
    font-size: 1.5rem;
    background: linear-gradient(310deg, #5e72e4, #825ee4);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.header-title-modern h4 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 700;
    color: #344767;
}

/* Subsection Header */
.subsection-header-modern {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    margin-bottom: 0.5rem;
    padding: 0.5rem 0;
    background: transparent;
    border: none;
    border-radius: 0;
}

.subsection-header-modern i {
    font-size: 1.125rem;
    color: #667eea;
}

.subsection-header-modern h5 {
    margin: 0;
    font-size: 1rem;
    font-weight: 700;
    color: #344767;
}

/* Fields Grid Compact - Para campos pequeños */
.fields-grid-compact {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.field-group-compact {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.form-label-modern {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    font-weight: 600;
    color: #344767;
    margin-bottom: 0.25rem;
}

.label-content-modern {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.label-content-modern i {
    font-size: 0.875rem;
    color: #667eea;
}

/* Input Modern */
.form-input-modern {
    width: 100%;
    padding: 0.625rem 0.875rem;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 400;
    color: #344767;
    transition: all 0.3s ease;
}

.form-input-modern:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-input-modern::placeholder {
    color: #adb5bd;
}

/* Gynecological Exams Section - Campo Principal */
.gynecological-exams-section {
    margin-top: 2rem;
    margin-bottom: 1.5rem;
}

/* Textarea Wrapper */
.textarea-wrapper-modern {
    position: relative;
    background: white;
    border: 2px solid #e9ecef;
    border-radius: 12px;
    transition: all 0.3s ease;
}

.textarea-wrapper-modern:focus-within {
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-textarea-modern {
    width: 100%;
    padding: 0.875rem 1rem;
    border: none;
    border-radius: 12px;
    font-size: 0.9375rem;
    font-weight: 400;
    color: #344767;
    line-height: 1.6;
    resize: vertical;
    min-height: 80px;
}

.form-textarea-modern:focus {
    outline: none;
}

.form-textarea-modern::placeholder {
    color: #adb5bd;
}

/* Textarea Footer */
.textarea-footer-modern {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 1rem;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    border-top: 1px solid #e9ecef;
    border-radius: 0 0 12px 12px;
}

.textarea-stats-modern {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.stat-item-modern {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    font-size: 0.75rem;
    color: #8392ab;
    font-weight: 500;
}

.stat-item-modern i {
    font-size: 0.75rem;
}

/* Help Text */
.help-text-modern {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.625rem 1rem;
    background: linear-gradient(135deg, #e7f3ff 0%, #f0f7ff 100%);
    border-left: 3px solid #5a9fd4;
    border-radius: 6px;
    font-size: 0.8125rem;
    color: #4a5568;
    margin-top: 0.5rem;
}

.help-text-modern i {
    font-size: 0.875rem;
    color: #5a9fd4;
}

/* Last Updated */
.last-updated-wrapper {
    margin-top: 0.5rem;
}

/* Campo Header Compact */
.field-header-compact {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
}

.toggle-expand-btn,
.add-content-btn {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #6b7280;
    flex-shrink: 0;
}

.toggle-expand-btn:hover {
    background: #667eea;
    border-color: #667eea;
    color: white;
    transform: scale(1.05);
}

.add-content-btn {
    background: white;
    border: 2px dashed #d1d5db;
}

.add-content-btn:hover {
    background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);
    border-color: #667eea;
    color: #667eea;
    transform: scale(1.05);
}

/* Sección de agregar campos */
.add-fields-section {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 1rem;
    padding: 0.75rem;
    background: #f8f9fa;
    border-radius: 8px;
}

.add-field-btn {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.375rem 0.75rem;
    background: white;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    color: #667eea;
    font-size: 0.813rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.add-field-btn i {
    font-size: 0.75rem;
}

.add-field-btn:hover {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-color: #667eea;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

/* Encabezado de campo con botón de cerrar */
.field-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
}

.close-field-btn {
    padding: 0.25rem 0.5rem;
    background: transparent;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    color: #6b7280;
    font-size: 0.75rem;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.close-field-btn:hover {
    background: #fee;
    border-color: #f87171;
    color: #dc2626;
}

/* Responsive */
@media (max-width: 768px) {
    .gynecology-section-modern {
        padding: 1rem;
    }

    .fields-grid-compact {
        grid-template-columns: 1fr;
    }
}
</style>
